import React, { FC } from 'react'

import { IconWatchProps } from './IconWatch.types'
import * as Styled from './styles/IconWatch.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWatch: FC<IconWatchProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWatchProps['size'],
  isResponsive = false,
}: IconWatchProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M17 13h15.328A2.67 2.67 0 0 1 35 15.672V31c0 2.21-1.79 4-4 4H17c-2.21 0-4-1.79-4-4V17c0-2.21 1.79-4 4-4Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m18 13 .883-7.063A1.071 1.071 0 0 1 19.945 5h8.11c.539 0 .996.402 1.062.938L30 13m0 22.07-.883 7.063a1.071 1.071 0 0 1-1.062.937h-8.11a1.07 1.07 0 0 1-1.062-.937L18 35.07'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.719 21.023v5.954M24 21.488v5.024m4.281-3.722v2.42'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconWatch
